// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../node_modules/decco/src/Decco.bs.js";
import * as Belt_Result from "../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as ErrorUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(value) {
  switch (value) {
    case "business_account" :
        return /* BusinessAccount */5;
    case "cash" :
        return /* Cash */0;
    case "instamojo" :
        return /* Instamojo */2;
    case "muneemji" :
        return /* Muneemji */6;
    case "online" :
        return /* Online */1;
    case "paytm" :
        return /* Paytm */4;
    case "razorpay" :
        return /* Razorpay */3;
    default:
      return ErrorUtils$Catalyst.raiseError("PaymentMode.re", "Not a PaymentMode", value);
  }
}

function toString(value) {
  switch (value) {
    case /* Cash */0 :
        return "cash";
    case /* Online */1 :
        return "online";
    case /* Instamojo */2 :
        return "instamojo";
    case /* Razorpay */3 :
        return "razorpay";
    case /* Paytm */4 :
        return "paytm";
    case /* BusinessAccount */5 :
        return "business_account";
    case /* Muneemji */6 :
        return "muneemji";
    
  }
}

function t_decode(json) {
  return Belt_Result.map(Decco.stringFromJson(json), fromString);
}

export {
  fromString ,
  toString ,
  t_decode ,
  
}
/* No side effect */
